<template>
  <div class="pannerWapper">
    <div class="pannel">
      <div class="title"><span class="titleIcon"></span>供应商</div>
      <div class="info">
        <div class="item-wrapper">
          <div class="tip">供应商数量</div>
          <div class="number">
            <span class="number_value">12</span>
            家
          </div>
        </div>
      </div>
    </div>
    <div class="pannel">
      <div class="title"><span class="titleIcon"></span>证书</div>
      <div class="info">
        <div class="item-wrapper">
          <div class="tip">证书覆盖小类数</div>
          <div class="number">
            <span class="number_value">15</span>
            个
          </div>
        </div>
        <div class="item-wrapper">
          <div class="tip">证书数量</div>
          <div class="number">
            <span class="number_value">25</span>
            个
          </div>
        </div>
      </div>
    </div>
    <div class="pannel">
      <div class="title"><span class="titleIcon"></span>报告</div>
      <div class="info">
        <div class="item-wrapper">
          <div class="tip">报告覆盖小类数</div>
          <div class="number">
            <span class="number_value">15</span>
            个
          </div>
        </div>
        <div class="item-wrapper">
          <div class="tip">报告数量</div>
          <div class="number">
            <span class="number_value">25</span>
            个
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.pannerWapper {
  display: flex;
  gap: 20px;
}
.pannel {
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px #0000001a;
  border-radius: 4px;
  min-width: 200px;
  width: 100%;
  height: 142px;
  padding: 20px;
  display: flex;
  color: #333;
  flex-direction: column;
  .title {
    font-size: 24px;
    line-height: 1;
    display: flex;
    align-items: center;
    .titleIcon {
      display: inline-block;
      width: 23px;
      height: 23px;
      background: red;
    }
  }
  .info {
    margin-top: 20px;
    display: flex;
    font-size: 20px;
    gap: 40px;
    .item-wrapper {
      min-width: 160px;
    }
    .tip {
      line-height: 1;
    }
    .number {
      margin-top: 10px;
      .number_value {
        font-size: 28px;
        font-weight: 500;
      }
    }
  }
}
</style>
